"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const RequiredIndicator_1 = require("./RequiredIndicator");
const constants_1 = require("../../constants");
const utils_1 = require("../../utils");
const Icon_1 = require("../Icon");
const Paragraph_1 = require("../Paragraph");
const LabelElement = styled_1.default.label((props) => ({
    alignItems: props.placement === 'top' ? undefined : 'center',
    display: 'flex',
    flexDirection: props.placement === 'top'
        ? 'column'
        : props.placement === 'right'
            ? 'row-reverse'
            : 'row',
    width: props.fullWidth ? '100%' : undefined,
    ...(0, utils_1.createStyles)(props.styles),
}));
const LabelDescription = (0, styled_1.default)(Paragraph_1.Paragraph)({
    marginBottom: 8,
});
const LabelText = styled_1.default.span((props) => ({
    alignItems: 'center',
    color: props.color ?? constants_1.Color.BLUE,
    cursor: props.cursor,
    display: 'flex',
    fontSize: props.size === 'sm' ? constants_1.theme.font.size[6] : constants_1.theme.font.size[6],
    fontWeight: constants_1.theme.font.weight.medium,
    gridGap: 8,
    marginBottom: props.placement === 'top' ? 8 : 0,
    marginLeft: props.placement === 'right' ? 8 : 0,
    marginRight: props.placement === 'left' ? 8 : 0,
}));
const Label = ({ placement = 'top', ...props }) => {
    return ((0, jsx_runtime_1.jsxs)(LabelElement, { className: props.className, styles: props.styles, fullWidth: props.fullWidth, htmlFor: props.for, placement: placement, children: [(0, jsx_runtime_1.jsxs)(LabelText, { className: "label-text", color: props.color, cursor: props.cursor, placement: placement, size: props.size, children: [props.icon && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { backgroundColor: constants_1.Color.LIGHTER_BLUE, name: props.icon, round: true, size: "sm" })), (0, jsx_runtime_1.jsxs)("span", { children: [props.text, !props.hideRequiredIndicator && ((0, jsx_runtime_1.jsx)(RequiredIndicator_1.RequiredIndicator, { required: !!props.required }))] })] }), props.description && ((0, jsx_runtime_1.jsx)(LabelDescription, { noMargin: true, children: props.description })), props.children] }));
};
exports.Label = Label;
